import { formatDate } from '@angular/common';
import { Component, Inject, Optional, OnInit } from '@angular/core';
import { AbstractControl, AbstractControlOptions, FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { CheckboxFieldTypeDto } from 'src/app/data-transfer/core-data/doc/checkbox-field-type-dto';
import { DOCDocumentDto } from 'src/app/data-transfer/core-data/doc/doc-document-dto';
import { EvidenceDto } from 'src/app/data-transfer/core-data/doc/evidence-dto';
import { EvidenceTypeDto } from 'src/app/data-transfer/core-data/doc/evidence-type-dto';
import { SectionTypeDto } from 'src/app/data-transfer/core-data/doc/section-type-dto';
import { CoreDataUpdateService } from 'src/app/data-transfer/services/core-data-update-api-service';
import { DialogActions } from 'src/app/model/dictionary';
import { SimpleAlertDialogComponent, SimpleDialogData } from '../simple-alert-dialog/simple-alert-dialog.component';
import { TranslocoService } from '@jsverse/transloco';
import { getDialogConfig } from 'src/app/util/dialog-util';
import moment from 'moment';

export class DOCDocumentDialogResult {
  document: DOCDocumentDto = new DOCDocumentDto();
  file!:File|null;
}

@Component({
  selector: 'app-add-doc-documents-dialog',
  templateUrl: './add-doc-documents-dialog.component.html',
  styleUrl: './add-doc-documents-dialog.component.scss'
})

export class AddDocDocumentsDialogComponent implements OnInit {
  protected prefix_result : string = "testresult_";
  protected prefix_start : string = "start_";
  protected prefix_end : string = "end_";

  private oldEvidences: string[] = [];
  private file: File|null = null;
  protected enableSave = false;

  document: DOCDocumentDto = new DOCDocumentDto();
  docDocumentFormGroup!: FormGroup;
  currentSection: SectionTypeDto;
  dialogActions = DialogActions;
  protected possibleEvidences = new Map<string, EvidenceTypeDto>();
  protected possibleCheckboxes = new Map<string, CheckboxFieldTypeDto>();

  constructor(
    protected coreDataUpdateService: CoreDataUpdateService,
    private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<AddDocDocumentsDialogComponent>,
    private translateService: TranslocoService,
    protected dialog: MatDialog,
    @Optional() @Inject(MAT_DIALOG_DATA) private data: SectionTypeDto
  ) {
    this.currentSection = this.data;
    this.possibleEvidences = coreDataUpdateService.allDOCEvidenceTypesMap;
  }

  ngOnInit() {
    let startevidences : string[] = [];
    if(this.currentSection.possibleEvidenceTypes.length === 1) {
      startevidences= [this.currentSection.possibleEvidenceTypes[0]]
    }
      this.docDocumentFormGroup = this.formBuilder.group({
        name: [this.document.name, [
          Validators.required
         ]],
        comment: [this.document.comment, [
          Validators.maxLength(250)
        ]],
        linkedEvidences: [startevidences,[
          Validators.required
        ]],
      });
      this.updateControls();
    }

  updateControls() {
    for (const evidence of this.docDocumentFormGroup.value.linkedEvidences) {
      if(!this.oldEvidences.includes(evidence)) {
        this.docDocumentFormGroup.addControl((this.prefix_result+evidence),new FormControl(null,[]));
        this.docDocumentFormGroup.addControl((this.prefix_start+evidence),new FormControl(null,[this.ValidDates(this.prefix_end+evidence,true)]));
        this.docDocumentFormGroup.addControl((this.prefix_end+evidence),new FormControl(null,[this.ValidDates(this.prefix_start+evidence,false)]));
      }
    }
    for (const evidence of this.oldEvidences) {
      if(!this.docDocumentFormGroup.value.linkedEvidences.includes(evidence)) {
        this.docDocumentFormGroup.removeControl((this.prefix_result+evidence));
        this.docDocumentFormGroup.removeControl((this.prefix_start+evidence));
        this.docDocumentFormGroup.removeControl((this.prefix_end+evidence));
      }
    }
    this.oldEvidences = this.docDocumentFormGroup.value.linkedEvidences
  }

  ValidDates(otherkey: string, isStart: boolean) {
    return (control:AbstractControl) : ValidationErrors | null => {
      const startDate = isStart? control.value : this.docDocumentFormGroup.value[otherkey];
      const endDate = isStart? this.docDocumentFormGroup.value[otherkey] : control.value;
      const errors: ValidationErrors = {};
      if(startDate && endDate) {
        const difference = moment(endDate).diff(moment(startDate), 'days', false);
        if (difference < 0) {
          errors.endBeforeStart = true;
        }
      }
      return errors;
    };
  }

  deleteAction() {
    this.dialogRef.close({ event: DialogActions.DELETE });
  }

  closeDialog() {
    this.dialogRef.close({ event: DialogActions.REJECT });
  }

  doAction() {
      Object.keys(this.docDocumentFormGroup.controls).forEach(field => {
        const control = this.docDocumentFormGroup.get(field);
        control?.markAsTouched({ onlySelf: true });
      });

      this.docDocumentFormGroup.updateValueAndValidity();
      if (this.docDocumentFormGroup.invalid) {
        return;
      } else {
        const docDocument: DOCDocumentDto = {
          name: this.docDocumentFormGroup.value.name,
          comment: this.docDocumentFormGroup.value.comment,
          documentId: -1,
          index: 0,
          linkedEvidences: []
        };
        Object.keys(this.docDocumentFormGroup.value).forEach(field => {
        if(field.startsWith(this.prefix_result)) {
          const evidenceId : string = field.split('_')[1];
          const evidence : EvidenceDto = {
            docEvidenceId: -1,
            evidenceType: evidenceId,
            testresult: this.docDocumentFormGroup.value[field],
            validFrom: this.docDocumentFormGroup.value[this.prefix_start+evidenceId] ?formatDate(this.docDocumentFormGroup.value[this.prefix_start+evidenceId], "YYYY-MM-ddT00:00:00+02:00", "en"): undefined ,
            validTo: this.docDocumentFormGroup.value[this.prefix_end+evidenceId] ? formatDate(this.docDocumentFormGroup.value[this.prefix_end+evidenceId], "YYYY-MM-ddT00:00:00+02:00", "en"): undefined,
          }
          docDocument.linkedEvidences.push(evidence);
        }
      });
        const result : DOCDocumentDialogResult = {
          document: docDocument,
          file: this.file,
        };
        this.dialogRef.close({ event: DialogActions.CONFIRM, data: result });
      }
    }

  private getInvalidPdfDialogData(fileName: string): SimpleDialogData {
      return {
        title: fileName,
        messages: [this.translateService.translate('errors.formatNotSupported')], icon: 'error'
      };
    }

  onUploadDocClick(files: FileList | null) {
    if(files && files.length > 0) {
      const relevantFile = files[0];
      const fileType = relevantFile.type;
      if (fileType.match(/application\/pdf/) === null) {
          const dialogData = this.getInvalidPdfDialogData(relevantFile.name);
          this.showDialog(dialogData);
          this.enableSave = false;
          return;
        }
        this.enableSave = true;
        this.file = relevantFile;
      } else {
        this.enableSave = false;
      }
  }

  getDownloadtitle(){
    //check for generalSection
    if(this.currentSection.id === '981048eb-9362-4de9-83d8-05a2c280727f') {
      return this.translateService.translate('docDocuments.uploadFile')
    }
    return this.translateService.translate('docDocuments.uploadEvidences')
  }

  getDefaultComment(){
    //check for generalSection
    if(this.currentSection.id === '981048eb-9362-4de9-83d8-05a2c280727f') {
      return this.translateService.translate('docDocuments.commentPlaceholder.generalSection')
    }
    return this.translateService.translate('docDocuments.commentPlaceholder.common')
  }

  protected showDialog(dialogData: SimpleDialogData, dialogWidth: string = '350px') {
      const alertDialogConfig = getDialogConfig(dialogData, dialogWidth);
      this.dialog.open(SimpleAlertDialogComponent, alertDialogConfig);
    }

  get formControls() { return this.docDocumentFormGroup.controls; }
}
